import { render, staticRenderFns } from "./NavBox.vue?vue&type=template&id=61fdd4e5&scoped=true"
import script from "./NavBox.vue?vue&type=script&lang=js"
export * from "./NavBox.vue?vue&type=script&lang=js"
import style0 from "./NavBox.vue?vue&type=style&index=0&id=61fdd4e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fdd4e5",
  null
  
)

export default component.exports